import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getBlogPosts, getBlogPostById, addBlogPost, deleteBlogPost, updateBlogPost } from '../../services/blogService';

export const fetchBlogPosts = createAsyncThunk('blog/fetchBlogPosts', async () => {
  return await getBlogPosts();
});

export const fetchBlogPostByIdThunk = createAsyncThunk('blog/fetchBlogPostById', async (id) => {
  return await getBlogPostById(id);
});

export const addNewPost = createAsyncThunk('blog/addNewPost', async (post) => {
  await addBlogPost(post);
  return await getBlogPosts(); // Refresh list
});

export const deletePost = createAsyncThunk('blog/deletePost', async (id) => {
  await deleteBlogPost(id);
  return id;
});

export const updatePost = createAsyncThunk('blog/updatePost', async ({ id, post }) => {
  await updateBlogPost(id, post);
  return await getBlogPosts(); // Refresh list
});

const blogSlice = createSlice({
  name: 'blog',
  initialState: {
    posts: [],
    loading: false,
    isLoading: false, // used by BlogPostPage
    error: null,
    currentPost: null,
  },
  reducers: {
    clearCurrentPost(state) {
      state.currentPost = null;
      state.error = null;
      state.isLoading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch All
      .addCase(fetchBlogPosts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBlogPosts.fulfilled, (state, action) => {
        state.loading = false;
        state.posts = action.payload || [];
        state.error = null;
      })
      .addCase(fetchBlogPosts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error?.message || 'Failed to load posts';
      })

      // Fetch One
      .addCase(fetchBlogPostByIdThunk.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.currentPost = null;
      })
      .addCase(fetchBlogPostByIdThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        state.currentPost = action.payload;
        state.error = null;
      })
      .addCase(fetchBlogPostByIdThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.currentPost = null;
        state.error = action.error?.message || 'Failed to load post';
      })

      // Add Post
      .addCase(addNewPost.fulfilled, (state, action) => {
        state.posts = action.payload;
      })

      // Delete Post
      .addCase(deletePost.fulfilled, (state, action) => {
        state.posts = state.posts.filter(post => post.id !== action.payload);
      })
      
      // Update Post
      .addCase(updatePost.fulfilled, (state, action) => {
        state.posts = action.payload;
      });
  },
});

export const { clearCurrentPost } = blogSlice.actions;
export default blogSlice.reducer;
